export enum RoleEnum {
    Applicant = 1,
    Acep = 2,
    Board = 3,
    Panel = 4,
    Site = 5,
    Board_Chair = 6,
    QC = 7
};

export class RoleEnumStatus {
    static getEnum(ordinal): RoleEnum {

        switch (ordinal) {
            case 1:
            case 'Applicant':
                return RoleEnum.Applicant;
            case 2:
            case 'Acep':
                return RoleEnum.Acep;
            case 3:
            case 'Board':
                return RoleEnum.Board;
            case 4:
            case 'Panel':
                return RoleEnum.Panel;
            case 6:
            case 'Board_Chair':
                return RoleEnum.Board_Chair;
            case 7:
            case 'QC':
                return RoleEnum.QC;


        }
    }



    static getPositionEnum(_ordinal): string {
        let ordinal = +_ordinal;
        switch (ordinal) {
            case 1:           
                return 'Applicant';

            case 2:           
            return 'Acep';

            case 3:           
                return "Board Reviewer";

            case 4:           
            return "Panel Reviewer";

            case 6:           
                return "Board_Chair";
                
            case 7:           
            return "QC Reviewer";


        }
    }
}







// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/enums/role.enum.ts